<template>
  <div class="main">
    <Tabs default-active-key="1" @change="callback" class="tabs">
      <TabPane key="1" tab="菜品订单">
        <div class="order-container" style="position:relative;">
          <!-- <div class="order-title">我的订单</div>
          <div class="break-line" /> -->

          <template v-show="monthOrderDatas.length && !requesting">
            <div class="order-view" id="container" ref="orderView">
              <div
                v-for="(todayOrderData, index) in todayOrderDatas"
                :key="index"
              >
                <div class="title-time">
                  <span class="icon-title">
                    <img
                      class="icon"
                      src="../../../static/img/user/icon_dp.png"
                    />
                    <span class="title">{{ todayOrderData.select_type }}</span>
                  </span>
                  <span class="time"
                    >订单时间：{{ todayOrderData.create_time }}</span
                  >
                </div>
                <OrderItem :orders="todayOrderData" @getOrders="getOrders" />
              </div>
            </div>
          </template>
          <div id="requesting" v-if="requesting" style="color: #ff7814; position:absolute;top:30%;left:50%;z-index:1;" class="la-pacman">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <p v-else-if="!todayOrderDatas.length" class="no-order">暂无订单</p>
          <OrderComment
            v-if="$store.state.user.order.show_comment_view"
            @getOrders="getOrders"
          />
        </div>
      </TabPane>
      <TabPane key="2" tab="咖啡订单" force-render>
        <CoffeeOrder />
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import OrderItem from "./order_item";
import OrderComment from "./order_comment";
import "../../../static/css/pacman.css";
import { Tabs } from "ant-design-vue";
import "ant-design-vue/lib/tabs/style/css";
import CoffeeOrder from'@/components/coffee/CoffeeOrder'
// import "ant-design-vue/lib/tabpane/style/css";
const { TabPane } = Tabs;
export default {
  name: "Order",
  components: {
    OrderItem,
    OrderComment,
    Tabs,
    TabPane,
    CoffeeOrder
  },
  data() {
    return {
      todayOrderDatas: [],
      requesting: false,
      loading: false,
      pageInfo: {
        page_now: 1,
      },
      isOver: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 获取订单数据
      this.getOrders();
      this.scroll();
    });
  },
  methods: {
    callback(key) {
      console.log(key);
    },
    /**
     * 获取当日订单数据
     */
    getOrders(from) {
      if (from === "child") {
        this.pageInfo.page_now = 1;
        this.todayOrderDatas = [];
      }
      this.requesting = true;
      let params = {
        user_id: this.$store.state.user_info.id,
        cmd: 3,
        page_now: this.pageInfo.page_now,
      };
      // 请求订单数据
      this.APIS.REQUEST_ORDERS(params)
        .then((res) => {
          if (res.data.status === 0 && res.data.order_data.length > 0) {
            // 给后端返回的结果 根据 create_time 再次排序
            const order_data = res.data.order_data;
            if (order_data.every(item => item.create_time)) {
              order_data.sort((a,b) => Date.parse(b.create_time) - Date.parse(a.create_time));
            }
            this.todayOrderDatas.push(...order_data);
            this.pageInfo.page_now += 1;
          } else if (res.data.order_data.length === 0) {
            this.isOver = true;
            this.$store.commit("show_alert", "订单加载完毕");
          }
          this.loading = false;
          this.requesting = false;
        })
        .catch(() => {
          this.requesting = false;
          this.$store.commit("show_alert", "登陆超时，请重新登录");
          // 跳转到登陆界面
          this.$router.push("/p/login");
        });
    },
    scroll() {
      this.loading = false;
      this.$nextTick(() => {
        console.log(this.$refs.orderView);
        this.$refs.orderView.addEventListener("scroll", () => {
          const offsetHeight = this.$refs.orderView.offsetHeight;
          const scrollTop = this.$refs.orderView.scrollTop;
          const scrollHeight = this.$refs.orderView.scrollHeight;
          let bottomOfWindow = offsetHeight + scrollTop - scrollHeight >= -1;
          if (bottomOfWindow && this.loading == false && !this.isOver) {
            this.loading = true;
            this.getOrders();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  padding: 20px;
    width: 1000px;
}
.order-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
    height: calc(100vh - 200px);
    /* height: 200px; */
    overflow-y: auto;
    overflow-x: hidden;
  .order-title {
    width: 900px;
    font-size: 20px;
    color: #333333;
    margin-top: 30px;
  }
  .break-line {
    width: 900px;
    margin-top: 20px;
    border-bottom: 1px solid #e0e0e0;
  }
  .la-pacman {
    margin-top: 50px;
  }
  .no-order {
    color: #999999;
  }
  .order-view {
    width: calc(~"100% - 16px");
    // height: calc(100% - 20px);

    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 6px;
    overflow: auto;
    .title-time {
      width: 900px;
      height: 36px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: #f5f5f5;
      border: solid 1px #e0e0e0;
      margin-top: 20px;
      .icon-title {
        display: flex;
        align-items: center;
        height: 36px;
        .icon {
          width: 20px;
          height: 20px;
          margin-left: 20px;
        }
        .title {
          font-size: 16px;
          color: #333333;
          margin-left: 5px;
        }
      }
      .time {
        font-size: 14px;
        color: #333333;
        margin-right: 20px;
      }
    }
  }
}
.tabs {
  // height: 100%;
  // overflow: auto;
  .ant-tabs-nav {
    left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/order.vue